export const PRODUCTO = 1;
export const SERVICIO = 2;